import { defineMessages } from 'react-intl-next';

export const messages: {
	teamLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	teamLabel: {
		id: 'dynamic-cards-search-page.team',
		defaultMessage: 'Team',
		description:
			'Team label text shown in people and teams search input where user can click to search for a team',
	},
});
